export class Service 
{
  Id: number;
  Name: string;
  Code: string;
  Description: string;
  IsLocked: boolean;
}
